import { formatDate, parseDate } from '@travelata-libs/utils';
import type { SearchCriteria, PartialSearchCriteria } from '../../model/types';

export interface CheckInDateRangeParams {
  dateFrom?: string;
  dateTo?: string;
  daysFlexible?: number;
}

const URL_DATE_FORMAT = 'dd.MM.yyyy';

/** ISO-дата `yyyy-MM-dd` → `DD.MM.YYYY` (как `moment(...).format('DD.MM.YYYY')` в источнике). */
function toUrlDate(iso: string): string {
  const parsed = parseDate(iso);
  return parsed ? formatDate(parsed, URL_DATE_FORMAT) : '';
}

export function checkInDateRange(criteria: SearchCriteria | PartialSearchCriteria): CheckInDateRangeParams {
  const range = criteria.dateRange;
  if (!range) {
    return {};
  }

  const params: CheckInDateRangeParams = {};
  if (range.from) {
    params.dateFrom = toUrlDate(range.from);
  }
  if (range.to) {
    params.dateTo = toUrlDate(range.to);
  }
  if (range.daysFlexible) {
    params.daysFlexible = range.daysFlexible;
  }

  return params;
}
